import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';

import Home from './pages/Home';
import Nosotros from './pages/Nosotros';
import Clases from './pages/Clases';
import Agenda from './pages/Agenda';
import Instructores from './pages/Instructores';
import Paquetes from './pages/Paquetes';
import Contacto from './pages/Contacto';
import Login from './pages/Login';
import Registro from './pages/Registro';

import CuentaLayout from './pages/cuenta/CuentaLayout';
import MisReservas from './pages/cuenta/MisReservas';
import Historial from './pages/cuenta/Historial';
import MiPaquete from './pages/cuenta/MiPaquete';
import Perfil from './pages/cuenta/Perfil';

import AdminLogin from './pages/admin/AdminLogin';
import CheckinClase from './pages/admin/CheckinClase';
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import ClasesAdmin from './pages/admin/ClasesAdmin';
import TiposClaseAdmin from './pages/admin/TiposClaseAdmin';
import InstructoresAdmin from './pages/admin/InstructoresAdmin';
import ReservasAdmin from './pages/admin/ReservasAdmin';
import ClientesAdmin from './pages/admin/ClientesAdmin';
import PaquetesAdmin from './pages/admin/PaquetesAdmin';
import Reportes from './pages/admin/Reportes';

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/nosotros" element={<Nosotros />} />
        <Route path="/clases" element={<Clases />} />
        <Route path="/agenda" element={<Agenda />} />
        <Route path="/instructores" element={<Instructores />} />
        <Route path="/paquetes" element={<Paquetes />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registro" element={<Registro />} />

        <Route
          path="/mi-cuenta"
          element={
            <ProtectedRoute>
              <CuentaLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="reservas" replace />} />
          <Route path="reservas" element={<MisReservas />} />
          <Route path="historial" element={<Historial />} />
          <Route path="paquete" element={<MiPaquete />} />
          <Route path="perfil" element={<Perfil />} />
        </Route>
      </Route>

      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin/checkin/:claseId"
        element={
          <ProtectedRoute roles={['admin', 'staff']}>
            <CheckinClase />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute roles={['admin', 'staff']}>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="clases" element={<ClasesAdmin />} />
        <Route path="tipos-clase" element={<TiposClaseAdmin />} />
        <Route path="instructores" element={<InstructoresAdmin />} />
        <Route path="reservas" element={<ReservasAdmin />} />
        <Route path="clientes" element={<ClientesAdmin />} />
        <Route path="paquetes" element={<PaquetesAdmin />} />
        <Route path="reportes" element={<Reportes />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
